import { forwardRef, InputHTMLAttributes } from 'react';

import { cn } from '@/utils/app.utils';

export interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, IInputProps>(
  ({
    className, type, error, ...props
  }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-[40px] w-full rounded-md border border-input bg-transparent px-3 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-800 placeholder:dark:text-neutral-500',
        className,
        error &&
        'border-error placeholder:text-error dark:border-error-dark dark:placeholder:text-error-dark'
      )}
      {...props}
    />
  )
);

Input.displayName = 'Input';

export { Input };
